import React from "react";
import { Text, Flex, Image, Box } from "@chakra-ui/react";
import LoadingSpinner from "../LoadingSpinner";

export default function Card(props) {
  const { title, total, icon } = props;
  return (
    <Box
      display="flex"
      w={"100%"}
      justifyContent="center"
      alignItems="center"
      shadow={"lg"}
      backgroundColor="#F7F8FB"
      rounded={"lg"}
      border="2px solid #E0E6ED"
      py={"30px"}
      px={"20px"}
      cursor={"pointer"}
      _hover={{
        backgroundColor: "#DDEBEA",
        ring: 3,
        ringColor: "#85B9E4",
      }}
    >
      {props?.loading ? (
        <Flex h={"100%"} alignItems={"center"} justifyContent={"center"}>
          <LoadingSpinner />
        </Flex>
      ) : (
        <>
          <Flex flexDir="row" alignItems="center" justifyContent="center">
            <Image mr={2} maxW={57} minW={57} src={icon} />

            <Flex flexDir="column" gap={2}>
              <Text
                fontSize={"15px"}
                textColor={"#3B3F5C"}
                fontWeight={"semibold"}
              >
                {title}
              </Text>
              <Text
                w={"max-content"}
                px={2}
                textColor="white"
                rounded={"full"}
                bg="#169499"
                fontSize={"16px"}
                fontWeight={"bold"}
              >
                Total: {total ? total : "0"}
              </Text>
            </Flex>
          </Flex>
        </>
      )}
    </Box>
  );
}
